module.exports = __webpack_public_path__ + "img/tab1.7b3c5df8.svg";